(function(){
  document.documentElement.classList.add('js');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(pointer: fine)').matches;
  const isMobile = innerWidth < 860;

  /* ---------- loader ---------- */
  const ln=document.getElementById('loadN'); let t0=performance.now();
  (function cnt(t){const p=Math.min(1,(t-t0)/1500);ln.textContent=String(Math.round(p*100)).padStart(3,'0');if(p<1)requestAnimationFrame(cnt)})(t0);

  /* ---------- titre en largeur variable ---------- */
  const mega=document.getElementById('mega');
  const letters=[...mega.textContent].map((ch,i)=>{const s=document.createElement('span');s.textContent=ch;s.setAttribute('aria-hidden','true');s.className='l-in';s.style.animationDelay=(1.75+i*0.06)+'s';return s});
  mega.textContent='';letters.forEach(s=>mega.appendChild(s));
  let mouseX=innerWidth/2, mouseY=innerHeight/2;
  function widthWave(){
    const r=mega.getBoundingClientRect();
    letters.forEach(s=>{
      const b=s.getBoundingClientRect(); const cx=b.left+b.width/2;
      const near = Math.abs(mouseY-(r.top+r.height/2)) < r.height*1.6;
      const d = Math.abs(mouseX-cx)/ (innerWidth*0.11);
      const f = near ? 1-Math.min(1,d) : 0; const w = 125 - f*40;
      s.style.fontVariationSettings='"wdth" '+w.toFixed(0)+', "wght" '+(900 - f*450).toFixed(0);
    });
  }
  // le titre remplit toujours la largeur, sans jamais déborder
  function fitMega(){mega.style.fontSize='';letters.forEach(s=>s.style.fontVariationSettings='');const cs=parseFloat(getComputedStyle(mega).fontSize);const w=letters[letters.length-1].getBoundingClientRect().right-letters[0].getBoundingClientRect().left, cw=mega.clientWidth;if(w>0)mega.style.fontSize=(cs*cw/w*.985)+'px'}
  fitMega(); if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitMega); addEventListener('resize',fitMega);
  let perf=0;

  /* ---------- curseur ---------- */
  const cur=document.querySelector('.cursor'), dot=document.querySelector('.cursor-dot');
  let cx=mouseX, cy=mouseY;
  if(fine){document.body.classList.add('has-cursor');}
  addEventListener('pointermove',e=>{mouseX=e.clientX;mouseY=e.clientY;dot.style.transform=`translate(${mouseX}px,${mouseY}px)`},{passive:true});
  document.querySelectorAll('a,button,label,.svc').forEach(el=>{
    el.addEventListener('pointerenter',()=>cur.classList.add('is-hover'));
    el.addEventListener('pointerleave',()=>cur.classList.remove('is-hover'));
  });

  /* ---------- boutons aimantés ---------- */
  if(fine) document.querySelectorAll('.magnet').forEach(el=>{
    el.addEventListener('pointermove',e=>{const b=el.getBoundingClientRect();const x=e.clientX-b.left-b.width/2,y=e.clientY-b.top-b.height/2;el.style.transform=`translate(${x*.25}px,${y*.35}px)`});
    el.addEventListener('pointerleave',()=>{el.style.transition='transform .5s cubic-bezier(.2,.8,.2,1)';el.style.transform='';setTimeout(()=>el.style.transition='',500)});
  });

  /* ---------- cartes : inclinaison + lumière ---------- */
  document.querySelectorAll('.svc').forEach(el=>{
    el.addEventListener('pointermove',e=>{
      const b=el.getBoundingClientRect(); const px=(e.clientX-b.left)/b.width, py=(e.clientY-b.top)/b.height;
      el.style.setProperty('--mx',(px*100)+'%'); el.style.setProperty('--my',(py*100)+'%');
      if(fine && !reduce) el.style.transform=`rotateY(${(px-.5)*10}deg) rotateX(${(.5-py)*10}deg)`;
    });
    el.addEventListener('pointerleave',()=>{el.style.transition='transform .7s cubic-bezier(.2,.8,.2,1),border-color .4s';el.style.transform='';setTimeout(()=>el.style.transition='',700)});
  });

  /* ---------- nav ---------- */
  const nav=document.getElementById('nav');

  /* ---------- manifeste mot à mot ---------- */
  const man=document.getElementById('manifest');
  const keys=['poignée','gravée.'];
  man.innerHTML=man.textContent.split(' ').map(w=>`<span class="w${keys.includes(w)?' key':''}">${w}</span>`).join(' ');
  const words=[...man.querySelectorAll('.w')];

  /* ---------- apparitions (seulement hors écran) ---------- */
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('pre');io.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('.reveal').forEach(el=>{if(el.getBoundingClientRect().top>innerHeight){el.classList.add('pre');io.observe(el)}});

  /* ---------- copier l'adresse ---------- */
  const mailEl=document.getElementById('mail');
  document.getElementById('copyMail').addEventListener('click',e=>{
    const b=e.currentTarget, txt=mailEl.textContent;
    const done=()=>{b.textContent='Adresse copiée';setTimeout(()=>b.textContent="Copier l'adresse",1800)};
    try{navigator.clipboard.writeText(txt).then(done,()=>{selectMail();b.textContent='Sélectionnée, faites Cmd+C'})}catch(_){selectMail()}
  });
  function selectMail(){const r=document.createRange();r.selectNodeContents(mailEl);const s=getSelection();s.removeAllRanges();s.addRange(r)}

  /* ---------- palette des services ---------- */
  const PAL={
    base:  ['#B9A6FF','#6FF0DA','#FF9EC7'],
    create:['#B9A6FF','#7FE3FF','#F1EDF7'],
    redo:  ['#FF9EC7','#FFB38A','#B9A6FF'],
    speed: ['#6FF0DA','#9FE8FF','#C9B8FF'],
    video: ['#FF6FA8','#FFD27A','#9B7BFF']
  };
  let palTarget=PAL.base;
  document.querySelectorAll('[data-palette]').forEach(el=>{
    el.addEventListener('pointerenter',()=>palTarget=PAL[el.dataset.palette]);
    el.addEventListener('pointerleave',()=>palTarget=PAL.base);
  });

  /* ---------- 3D ---------- */
  let gl=null;
  try{ if(window.THREE){ gl=initGL(); } }catch(err){ gl=null }
  if(!gl) document.documentElement.classList.add('no-gl');

  function initGL(){
    const canvas=document.getElementById('gl');
    const renderer=new THREE.WebGLRenderer({canvas,antialias:true,alpha:true,powerPreference:'high-performance'});
    renderer.setPixelRatio(Math.min(devicePixelRatio,isMobile?1.5:2));
    renderer.setSize(innerWidth,innerHeight,false);
    renderer.setClearColor(0x000000,0);
    const scene=new THREE.Scene();
    const cam=new THREE.PerspectiveCamera(38,innerWidth/innerHeight,.1,100);
    cam.position.set(0,0,7);

    const noise=`
      vec3 mod289(vec3 x){return x-floor(x*(1./289.))*289.;}
      vec4 mod289(vec4 x){return x-floor(x*(1./289.))*289.;}
      vec4 permute(vec4 x){return mod289(((x*34.)+1.)*x);}
      vec4 taylorInvSqrt(vec4 r){return 1.79284291400159-.85373472095314*r;}
      float snoise(vec3 v){
        const vec2 C=vec2(1./6.,1./3.);const vec4 D=vec4(0.,.5,1.,2.);
        vec3 i=floor(v+dot(v,C.yyy));vec3 x0=v-i+dot(i,C.xxx);
        vec3 g=step(x0.yzx,x0.xyz);vec3 l=1.-g;vec3 i1=min(g.xyz,l.zxy);vec3 i2=max(g.xyz,l.zxy);
        vec3 x1=x0-i1+C.xxx;vec3 x2=x0-i2+C.yyy;vec3 x3=x0-D.yyy;
        i=mod289(i);
        vec4 p=permute(permute(permute(i.z+vec4(0.,i1.z,i2.z,1.))+i.y+vec4(0.,i1.y,i2.y,1.))+i.x+vec4(0.,i1.x,i2.x,1.));
        float n_=.142857142857;vec3 ns=n_*D.wyz-D.xzx;
        vec4 j=p-49.*floor(p*ns.z*ns.z);vec4 x_=floor(j*ns.z);vec4 y_=floor(j-7.*x_);
        vec4 x=x_*ns.x+ns.yyyy;vec4 y=y_*ns.x+ns.yyyy;vec4 h=1.-abs(x)-abs(y);
        vec4 b0=vec4(x.xy,y.xy);vec4 b1=vec4(x.zw,y.zw);
        vec4 s0=floor(b0)*2.+1.;vec4 s1=floor(b1)*2.+1.;vec4 sh=-step(h,vec4(0.));
        vec4 a0=b0.xzyw+s0.xzyw*sh.xxyy;vec4 a1=b1.xzyw+s1.xzyw*sh.zzww;
        vec3 p0=vec3(a0.xy,h.x);vec3 p1=vec3(a0.zw,h.y);vec3 p2=vec3(a1.xy,h.z);vec3 p3=vec3(a1.zw,h.w);
        vec4 norm=taylorInvSqrt(vec4(dot(p0,p0),dot(p1,p1),dot(p2,p2),dot(p3,p3)));
        p0*=norm.x;p1*=norm.y;p2*=norm.z;p3*=norm.w;
        vec4 m=max(.6-vec4(dot(x0,x0),dot(x1,x1),dot(x2,x2),dot(x3,x3)),0.);m=m*m;
        return 42.*dot(m*m,vec4(dot(p0,x0),dot(p1,x1),dot(p2,x2),dot(p3,x3)));
      }`;

    const uniforms={
      uTime:{value:0}, uMouse:{value:new THREE.Vector2()}, uAmp:{value:.018}, uL:{value:new THREE.Vector3(.8,.3,-.6)},
      uA:{value:new THREE.Color(PAL.base[0])}, uB:{value:new THREE.Color(PAL.base[1])}, uC:{value:new THREE.Color(PAL.base[2])}
    };
    // la lune rose poudre : surface nacrée, croissant éclairé par une lumière qui tourne autour d'elle
    const mat=new THREE.ShaderMaterial({uniforms,
      vertexShader:noise+`
        uniform float uTime,uAmp;
        varying vec3 vN; varying vec3 vW; varying vec3 vO;
        void main(){
          vec3 d=normalize(position);
          float s=snoise(d*2.2+vec3(0.,uTime*.12,0.));
          vec3 p=d*(1.+s*uAmp);
          vO=d;
          vec4 w=modelMatrix*vec4(p,1.);
          vW=w.xyz; vN=normalize(mat3(modelMatrix)*d);
          gl_Position=projectionMatrix*viewMatrix*w;
        }`,
      fragmentShader:noise+`
        uniform vec3 uA,uB,uC,uL; uniform float uTime;
        varying vec3 vN; varying vec3 vW; varying vec3 vO;
        float fbm(vec3 p){float a=.5,f=0.;for(int i=0;i<4;i++){f+=a*snoise(p);p*=2.03;a*=.5;}return f;}
        void main(){
          vec3 N=normalize(vN); vec3 V=normalize(cameraPosition-vW); vec3 L=normalize(uL);
          float ndv=clamp(dot(N,V),0.,1.);
          float lit=dot(N,L);
          float term=smoothstep(-.06,.32,lit);
          float c=fbm(vO*3.2);
          float mare=smoothstep(.05,.55,snoise(vO*1.35+3.1));
          float t=ndv*1.1+c*.6+uTime*.035;
          vec3 ir=uA*(.5+.5*cos(6.2831*t))+uB*(.5+.5*cos(6.2831*(t+.33)))+uC*(.5+.5*cos(6.2831*(t+.66)));
          ir/=1.35;
          vec3 pearl=vec3(1.,.85,.90);
          vec3 albedo=mix(pearl,ir,.08)*(.80+.28*c)*(1.-.26*mare);
          vec3 col=albedo*term*(.78+.32*max(lit,0.));
          col+=vec3(.035,.02,.03)+ir*.015;
          float fres=pow(1.-ndv,3.);
          col+=mix(ir,vec3(1.,.72,.84),.55)*fres*(.25+1.2*term);
          float sp=pow(max(dot(reflect(-L,N),V),0.),36.)*term;
          col+=sp*.4*vec3(1.,.9,.94);
          gl_FragColor=vec4(col,1.);
        }`
    });
    const geo=new THREE.SphereGeometry(1.35,isMobile?96:160,isMobile?64:120);
    const blob=new THREE.Mesh(geo,mat); scene.add(blob);
    // halo rose autour du croissant
    const haloMat=new THREE.ShaderMaterial({uniforms:{uA:uniforms.uA,uC:uniforms.uC,uL:uniforms.uL},side:THREE.BackSide,transparent:true,depthWrite:false,blending:THREE.AdditiveBlending,
      vertexShader:`varying float vI; varying vec3 vNw; void main(){ vec3 vn=normalize(normalMatrix*normal); vI=pow(max(-dot(vn,vec3(0.,0.,1.)),0.),2.6); vNw=normalize(mat3(modelMatrix)*normal); gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.); }`,
      fragmentShader:`uniform vec3 uA,uC,uL; varying float vI; varying vec3 vNw; void main(){ float side=.25+.75*smoothstep(-.3,.8,dot(normalize(vNw),normalize(uL))); float a=clamp(vI*side*.9,0.,1.); gl_FragColor=vec4(mix(vec3(1.,.74,.86),uC,.35),a); }`});
    const halo=new THREE.Mesh(new THREE.SphereGeometry(1.35*1.28,64,48),haloMat); blob.add(halo);

    // anneau de particules
    const N=isMobile?900:1800, pos=new Float32Array(N*3), sz=new Float32Array(N);
    for(let i=0;i<N;i++){
      const r=2.15+Math.pow(Math.random(),1.6)*1.25, a=Math.random()*Math.PI*2, y=(Math.random()-.5)*.12;
      pos[i*3]=Math.cos(a)*r; pos[i*3+1]=y; pos[i*3+2]=Math.sin(a)*r; sz[i]=Math.random();
    }
    const pg=new THREE.BufferGeometry(); pg.setAttribute('position',new THREE.BufferAttribute(pos,3)); pg.setAttribute('aS',new THREE.BufferAttribute(sz,1));
    const pm=new THREE.ShaderMaterial({transparent:true,depthWrite:false,blending:THREE.AdditiveBlending,uniforms:{uTime:uniforms.uTime,uPR:{value:renderer.getPixelRatio()},uA:uniforms.uA,uC:uniforms.uC},
      vertexShader:`attribute float aS; uniform float uTime,uPR; varying float vS;
        void main(){vS=aS; vec4 mv=modelViewMatrix*vec4(position,1.); gl_Position=projectionMatrix*mv; gl_PointSize=(1.5+aS*3.5)*uPR*(6./-mv.z);}`,
      fragmentShader:`uniform vec3 uA,uC; varying float vS; void main(){ float d=length(gl_PointCoord-.5); float a=smoothstep(.5,0.,d); gl_FragColor=vec4(mix(mix(uC,vec3(1.,.86,.92),.5),uA,vS*.35),a*(.35+vS*.5)); }`});
    const ring=new THREE.Points(pg,pm); ring.rotation.x=.42; ring.rotation.z=-.18; scene.add(ring);

    const group={blob,ring};
    addEventListener('resize',()=>{renderer.setSize(innerWidth,innerHeight,false);cam.aspect=innerWidth/innerHeight;cam.updateProjectionMatrix()});
    return {renderer,scene,cam,uniforms,group};
  }

  /* ---------- boucle ---------- */
  const lerp=(a,b,t)=>a+(b-a)*t;
  const glSecs=[...document.querySelectorAll('[data-gl]')];
  let sm={x:0,y:0}, scrollP=0, last=performance.now(), time=0;
  const tmpB=window.THREE?new THREE.Color():null;
  const speed = reduce ? .35 : 1;

  function frame(now){
    const dt=Math.min(.05,(now-last)/1000); last=now; time+=dt*speed; perf=now;
    cx=lerp(cx,mouseX,.18); cy=lerp(cy,mouseY,.18); if(cur) cur.style.transform=`translate(${cx}px,${cy}px)`;
    nav.classList.toggle('is-scrolled',scrollY>40);
    if(fine) widthWave();
    const mr=man.getBoundingClientRect();
    const mp=Math.max(0,Math.min(1,(innerHeight*.85-mr.top)/(mr.height+innerHeight*.35)));
    const on=Math.round(mp*words.length); words.forEach((w,i)=>w.classList.toggle('on',i<on));
    if(gl && !document.hidden){
      const u=gl.uniforms;
      u.uTime.value=time;
      sm.x=lerp(sm.x,(mouseX/innerWidth-.5)*2,.05); sm.y=lerp(sm.y,(mouseY/innerHeight-.5)*2,.05);
      u.uMouse.value.set(sm.x,-sm.y);
      ['uA','uB','uC'].forEach((k,i)=>{tmpB.set(palTarget[i]);u[k].value.lerp(tmpB,.06)});
      const docH=Math.max(1,document.documentElement.scrollHeight-innerHeight);
      scrollP=lerp(scrollP,scrollY/docH,.08);
      const b=gl.group.blob, r=gl.group.ring;
      // chaque section dit où la lune se place (data-gl="x y échelle", data-glm sur mobile)
      const mob=innerWidth<860;
      let tgt=mob?[0,1.05,.85]:[1.85,.35,1.22];
      const mid=innerHeight*.5;
      for(const s of glSecs){const r0=s.getBoundingClientRect(); if(r0.top<=mid&&r0.bottom>=mid){tgt=(mob?(s.dataset.glm||s.dataset.gl):s.dataset.gl).split(' ').map(Number);break}}
      const k=scrollP;
      b.position.x=lerp(b.position.x,tgt[0]+sm.x*.15,.08); b.position.y=lerp(b.position.y,tgt[1]-sm.y*.12,.08);
      b.scale.setScalar(lerp(b.scale.x,tgt[2],.08));
      // la lune tourne doucement au fil du défilement
      b.rotation.y=lerp(b.rotation.y,scrollY*.0011+time*.01,.06); b.rotation.x=lerp(b.rotation.x,sm.y*.15,.05); b.rotation.z=lerp(b.rotation.z,Math.sin(k*Math.PI)*.12,.05);
      r.position.copy(b.position); r.scale.copy(b.scale); r.rotation.y+=dt*.06*speed;
      // phase : fin croissant en haut de page, presque pleine lune en bas ; la souris fait tourner la lumière
      const ph=1.75-k*1.35+sm.x*.55;
      u.uL.value.set(Math.sin(ph),.32-sm.y*.35,Math.cos(ph));
      gl.renderer.render(gl.scene,gl.cam);
    }
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
})();